module.exports = __webpack_public_path__ + "img/ico-customers.98c5b84.svg";